import React from "react";
import { View } from "react-native";
import { ChevronLeft, ChevronRight } from "lucide-react-native";
import { PressableWrap } from "../../Universal/Buttons/PressableColorWrap/PressableColorWrap";

interface ImageSwiperNavigationProps {
  activeIndex: number;
  imagesCount: number;
  navButtonStyle: object;
  navOverlayStyle: object;
  scaleAll: number;
  sideStyle: object;
  onFocus: () => void;
  onNext: () => void;
  onPrev: () => void;
}

const ImageSwiperNavigation: React.FC<ImageSwiperNavigationProps> = ({
  activeIndex,
  imagesCount,
  navButtonStyle,
  navOverlayStyle,
  scaleAll,
  sideStyle,
  onFocus,
  onNext,
  onPrev,
}) => {
  if (imagesCount <= 1) return null;

  return (
    <View pointerEvents="box-none" style={navOverlayStyle}>
      <View style={sideStyle}>
        {activeIndex > 0 ? (
          <PressableWrap
            onPress={() => {
              onFocus();
              onPrev();
            }}
            style={navButtonStyle}
          >
            <ChevronLeft size={26 * scaleAll} strokeWidth={2} color="#000" />
          </PressableWrap>
        ) : null}
      </View>

      <View style={sideStyle}>
        {activeIndex < imagesCount - 1 ? (
          <PressableWrap
            onPress={() => {
              onFocus();
              onNext();
            }}
            style={navButtonStyle}
          >
            <ChevronRight size={26 * scaleAll} strokeWidth={2} color="#000" />
          </PressableWrap>
        ) : null}
      </View>
    </View>
  );
};

export default React.memo(ImageSwiperNavigation);
